module.exports = {
    recorridoData: () => {
        return[
            {
                "START": {
                    "Image": require("./../assets/panoramas/General_01.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-19.000 0 -6.149",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.75 0.75",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.691 -1.481 -9.479",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.027 -0.791 -0.120",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-9.453 -0.791 8.677",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-21.811 -1.481 -12.027",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                    ],
                    "Labels":[
                        {
                            "Position":"-20.484 4.945 0.040",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"MOTO MES",
                            "Image": require('./../UI/labels/raider-125.svg').default
                        },
                        {
                            "Position":"-9.858 3.524 -20.955",
                            "Rotation":"0 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA NTORQ",
                            "Image": require('./../UI/labels/familia-ntorq.svg').default
                        },
                        {
                            "Position":"-32.982 3.524 -20.955",
                            "Rotation":"-15.061 26.753 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/familia-motocarro.svg').default
                        },
                        {
                            "Position":"-12.543 3.524 19.590",
                            "Rotation":"-15.061 178.499 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA APACHE",
                            "Image": require('./../UI/labels/familia-apache.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-19.830 0.471 0.1558",
                            "Rotation":"0 90.000 0",
                            "Scale":"5.747 6.344",
                            "goTo":"MOTO MES",
                        },
                        {
                            "Position":"-8.411 0.471 -17.334",
                            "Rotation":"0 0.735 0",
                            "Scale":"15.347 6.344",
                            "goTo":"FAMILIA NTORQ",
                        },
                        {
                            "Position":"-33.607 0.471 -20.265",
                            "Rotation":"0 -0.823 0",
                            "Scale":"24.334 6.344",
                            "goTo":"FAMILIA MOTOCARRO",
                        },
                        {
                            "Position":"-16.473 0.471 21.400",
                            "Rotation":"0 -0.823 0",
                            "Scale":"34.427 6.344",
                            "goTo":"FAMILIA APACHE",
                        }
                    ]
                },
                "GENERAL1": {
                    "Image": require("./../assets/panoramas/General_02.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"16.850 0 -3.465",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.096 0 -6.731",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-5.775 0 -3.095",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"-5.562 0 2.342",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"10.940 0 -4.468",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"6.730 0 8.161",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                    ],
                    "Labels":[
                        {
                            "Position":"28.352 4.945 2.943",
                            "Rotation":"-15.061 -90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"MOTO MES",
                            "Image": require('./../UI/labels/raider-125.svg').default
                        },
                        {
                            "Position":"31.170 3.524 -20.955",
                            "Rotation":"0 -40.270 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA NTORQ",
                            "Image": require('./../UI/labels/familia-ntorq.svg').default
                        },
                        {
                            "Position":"1.276 5.406 -38.543",
                            "Rotation":"-15.061 26.753 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/familia-motocarro.svg').default
                        },
                        {
                            "Position":"15.352 3.524 24.339",
                            "Rotation":"-15.061 -141.078 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA APACHE",
                            "Image": require('./../UI/labels/familia-apache.svg').default
                        },
                        {
                            "Position":"-30.662 5.406 -14.492",
                            "Rotation":"0 45 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Neo NX 110",
                            "Image": require('./../UI/labels/neo-nx.png').default
                        },
                        {
                            "Position":"-20.154 3.659 12.248",
                            "Rotation":"0 125 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA SPORT",
                            "Image": require('./../UI/labels/familia-sport.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"21.934 0.471 2.332",
                            "Rotation":"0 -90.000 0",
                            "Scale":"5.747 6.344",
                            "goTo":"MOTO MES",
                        },
                        {
                            "Position":"27.965 0.471 -16.397",
                            "Rotation":"0 -27.355 0",
                            "Scale":"15.347 6.344",
                            "goTo":"FAMILIA NTORQ",
                        },
                        {
                            "Position":"0.446 0.471 -20.313",
                            "Rotation":"0 -0.823 0",
                            "Scale":"27.450 6.344",
                            "goTo":"FAMILIA MOTOCARRO",
                        },
                        {
                            "Position":"24.019 0.471 28.506",
                            "Rotation":"0 -0.823 0",
                            "Scale":"37.434 6.344",
                            "goTo":"FAMILIA APACHE",
                        },
                        {
                            "Position":"-23.792 0.471 -11.213",
                            "Rotation":"0 45 0",
                            "Scale":"8.871 6.344",
                            "goTo":"Neo NX 110",
                        },
                        {
                            "Position":"-21.002 0.471 9.590",
                            "Rotation":"0 -42.893 0",
                            "Scale":"31.264 6.344",
                            "goTo":"FAMILIA SPORT",
                        }
                    ]
                },

                "FAMILIA APACHE": {
                    "Image": require("./../assets/panoramas/TVSapacheFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"9.655 0 8.472",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        },
                        {
                            "Position":"13.377 0 -10.266",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.600 0 4.792",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"15.769 0 -6.024",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"13.205 0 -15.451",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"7.402 0 -14.160",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"0.338 0 5.537",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"-1.930 0 4.334",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"-3.476 0 1.554",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"-3.000 0 -0.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-1.890 0 -2.308",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"0.166 0 -4.086",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        },
                    ],
                    "Labels":[
                        {
                            "Position":"28.352 4.945 2.943",
                            "Rotation":"-15.061 -90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"MOTO MES",
                            "Image": require('./../UI/labels/raider-125.svg').default
                        },
                        {
                            "Position":"-2.043 4.945 21.651",
                            "Rotation":"0 155.497 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 160 2V",
                            "Image": require('./../UI/labels/rtr-160-2v.png').default
                        },
                        {
                            "Position":"-9.224 4.945 18.452",
                            "Rotation":"0 138.914 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 160 4V",
                            "Image": require('./../UI/labels/rtr-160-4v.png').default
                        },
                        {
                            "Position":"-15.691 4.945 7.451",
                            "Rotation":"0 138.914 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 180 2V",
                            "Image": require('./../UI/labels/rtr-180-2v.png').default
                        },
                        {
                            "Position":"-17.835 4.665 -1.276",
                            "Rotation":"0 91.893 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 2V",
                            "Image": require('./../UI/labels/rtr-200-4v.png').default
                        },
                        {
                            "Position":"-10.683 4.665 -13.056",
                            "Rotation":"0 51.318 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 fi",
                            "Image": require('./../UI/labels/rtr-200-4v-fi.png').default
                        },
                        {
                            "Position":"-3.597 4.665 -20.652",
                            "Rotation":"0 50.637 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 fi",
                            "Image": require('./../UI/labels/rr-310.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"21.934 0.471 2.332",
                            "Rotation":"0 -90.000 0",
                            "Scale":"5.747 6.344",
                            "goTo":"MOTO MES",
                        },
                        {
                            "Position":"-1.465 0.604 16.446",
                            "Rotation":"0 -41.068 0",
                            "Scale":"4.2 6.344",
                            "goTo":"Apache 160 2V",
                        },
                        {
                            "Position":"-6.217 0.604 12.305",
                            "Rotation":"0 -41.068 0",
                            "Scale":"3.932 6.344",
                            "goTo":"Apache 160 4V",
                        },
                        {
                            "Position":"-10.178 0.604 4.739",
                            "Rotation":"0 -41.068 0",
                            "Scale":"3.932 6.344",
                            "goTo":"Apache 180 2V",
                        },
                        {
                            "Position":"-10.998 0.604 -0.621",
                            "Rotation":"0 61.298 0",
                            "Scale":"3.932 6.344",
                            "goTo":"Apache 200 2V",
                        },
                        {
                            "Position":"-6.134 0.604 -7.837",
                            "Rotation":"0 61.298 0",
                            "Scale":"3.932 6.344",
                            "goTo":"Apache 200 fi",
                        },
                        {
                            "Position":"-1.480 0.604 -11.079",
                            "Rotation":"0 42.776 0",
                            "Scale":"5.828 6.344",
                            "goTo":"Apache RR 310",
                        }
                    ]
                },
                "FAMILIA MOTOCARRO": {
                    "Image": require("./../assets/panoramas/TVSmotocarroFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"5.993 0 -13.998",
                            "Rotation":"-88.406 0.000 90",
                            "Scale":"0.7 0.7",
                            "goTo":"START"
                        },
                        {
                            "Position":"1.699 0 5.875",
                            "Rotation":"-90 0.000 90",
                            "Scale":"0.45 0.45",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"13.292 0 -2.928",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-1.690 0 9.273",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"6.594 0 9.273",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"1.892 0 -10.896",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.736 0 -5.133",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"Motocarro King Basico"
                        },
                        {
                            "Position":"-2.433 0 -0.957",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                        {
                            "Position":"-3.373 0 2.974",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full"
                        },
                    ],
                    "Labels":[
                        {
                            "Position":"-8.697 3.791 -0.096",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Carpa Especial",
                            "Image": require('./../UI/labels/king-especial.png').default
                        },
                        {
                            "Position":"-8.697 3.791 6.956",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Carpa Full",
                            "Image": require('./../UI/labels/king-full.png').default
                        },
                        {
                            "Position":"-8.697 3.791 -8.419",
                            "Rotation":"0 60.694 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Carpa Basico",
                            "Image": require('./../UI/labels/king.png').default
                        },
                        {
                            "Position":"-0.628 3.791 -22.307",
                            "Rotation":"0 25.782 0",
                            "Scale":"7.235 1.024",
                            "goTo":"AMILIA NTORQ",
                            "Image": require('./../UI/labels/familia-ntorq.svg').default
                        },
                        {
                            "Position":"-6.418 3.791 25.441",
                            "Rotation":"0 143.520 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Neo NX 110",
                            "Image": require('./../UI/labels/neo-nx.png').default
                        },
                        {
                            "Position":"19.908 4.646 -18.666",
                            "Rotation":"0 -45 0",
                            "Scale":"7.235 1.024",
                            "goTo":"MOTO MES",
                            "Image": require('./../UI/labels/raider-125.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-8.697 0.471 -0.096",
                            "Rotation":"0 -90.000 0",
                            "Scale":"5.747 6.344",
                            "goTo":"Motocarro King Carpa Especial",
                        },
                        {
                            "Position":"-10.165 0.471 8.370",
                            "Rotation":"0 90.943 0",
                            "Scale":"5.747 6.344",
                            "goTo":"Motocarro King Carpa Full",
                        },
                        {
                            "Position":"-9.977 0.471 -9.556",
                            "Rotation":"0 45.735 0",
                            "Scale":"10.012 6.344",
                            "goTo":"Motocarro King Basico",
                        },
                        {
                            "Position":"-0.933 0.471 -26.548",
                            "Rotation":"0 37.4682 0",
                            "Scale":"14.269 6.344",
                            "goTo":"FAMILIA NTORQ",
                        },
                        {
                            "Position":"-6.121 0.471 26.473",
                            "Rotation":"0 126.772 0",
                            "Scale":"10.012 6.344",
                            "goTo":"Neo NX 110",
                        },
                        {
                            "Position":"21.607 0.471 -20.596",
                            "Rotation":"0 -45.000 0",
                            "Scale":"14.269 6.344",
                            "goTo":"MOTO MES",
                        }
                    ]
                },
                "FAMILIA NTORQ": {
                    "Image": require("./../assets/panoramas/Ntorq125Familia.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.706 0 -6.044",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"0.706 0 15.690",
                            "Rotation":"-84.357 180.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-3.063 0 9.692",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"12.197 0 0.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"4.503 0 -2.274",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.35 0.35",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-4.197 -0.510 2.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi"
                        },
                        {
                            "Position":"-3.698 -0.510 -0.923",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"-3.008 -0.510 -4.407",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125"
                        },
                    ],
                    "Labels":[
                        {
                            "Position":"-14.645 4.211 8.144",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125 fi",
                            "Image": require('./../UI/labels/ntorq-fi.png').default
                        },
                        {
                            "Position":"-14.394 4.191 0.322",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125 Racing",
                            "Image": require('./../UI/labels/ntorq-race.png').default
                        },
                        {
                            "Position":"-15.487 4.329 -7.783",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125",
                            "Image": require('./../UI/labels/ntorq.png').default
                        },
                        {
                            "Position":"-13.510 4.777 35.550",
                            "Rotation":"0 139.605 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/familia-motocarro.svg').default
                        },
                        {
                            "Position":"15.889 6.506 5.591",
                            "Rotation":"0 -90 0",
                            "Scale":"7.235 1.024",
                            "goTo":"MOTO MES",
                            "Image": require('./../UI/labels/raider-125.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-8.839 0.471 4.924",
                            "Rotation":"0 -78.685 0",
                            "Scale":"4.437 6.344",
                            "goTo":"Ntorq 125 fi",
                        },
                        {
                            "Position":"-8.839 0.471 -0.346",
                            "Rotation":"0 -78.685 0",
                            "Scale":"4.437 6.344",
                            "goTo":"Ntorq 125 Racing",
                        },
                        {
                            "Position":"-12.316 0.022 -6.749",
                            "Rotation":"0 -131.362 0",
                            "Scale":"7.887 6.344",
                            "goTo":"Ntorq 125",
                        },
                        {
                            "Position":"-8.839 0.471 25.610",
                            "Rotation":"0 -74.298 0",
                            "Scale":"19.191 6.344",
                            "goTo":"FAMILIA MOTOCARRO",
                        },
                        {
                            "Position":"9.094 0.471 3.171",
                            "Rotation":"0 -107.595 0",
                            "Scale":"4.437 6.344",
                            "goTo":"MOTO MES",
                        },
                    ]
                },
                "FAMILIA SPORT": {
                    "Image": require("./../assets/panoramas/TVSsportFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.511 0 -2.533",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.328 0 -8.111",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"11.011 0 -2.474",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"8.818 0 11.289",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.509 0 -4.169",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-2.900 0 -1.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-2.817 0 2.078",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"-2.151 0 4.659",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS"
                        },
                    ],
                    "Labels":[
                        {
                            "Position":"-14.645 4.167 6.025",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Max 125",
                            "Image": require('./../UI/labels/max-125.png').default
                        },
                        {
                            "Position":"-14.394 4.191 -4.502",
                            "Rotation":"-15.061 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Stryker",
                            "Image": require('./../UI/labels/stryker-125.png').default
                        },
                        {
                            "Position":"-12.192 4.329 -15.868",
                            "Rotation":"0 69.108 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Sport 100 KLS",
                            "Image": require('./../UI/labels/sport-100-kls.png').default
                        },
                        {
                            "Position":"-13.049 3.266 15.860",
                            "Rotation":"0 139.605 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Sport 100 ELS",
                            "Image": require('./../UI/labels/sport-100-els.png').default
                        },
                        {
                            "Position":"5.907 4.149 -25.801",
                            "Rotation":"0 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Neo NX 110",
                            "Image": require('./../UI/labels/neo-nx.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-9.014 -0.270 4.051",
                            "Rotation":"0 -90 0",
                            "Scale":"4.437 6.344",
                            "goTo":"Max 125",
                        },
                        {
                            "Position":"-8.605 0.471 -2.995",
                            "Rotation":"0 -92.570 0",
                            "Scale":"4.437 6.344",
                            "goTo":"Stryker",
                        },
                        {
                            "Position":"-10.722 0.022 -14.396",
                            "Rotation":"0 -131.362 0",
                            "Scale":"7.887 6.344",
                            "goTo":"Sport 100 KLS",
                        },
                        {
                            "Position":"-10.135 -0.350 11.915",
                            "Rotation":"0 -23.128 0",
                            "Scale":"6.191 6.344",
                            "goTo":"Sport 100 ELS",
                        },
                        {
                            "Position":"5.398 0.900 -22.019",
                            "Rotation":"0 -0.158 0",
                            "Scale":"4.437 6.344",
                            "goTo":"Neo NX 110",
                        },
                    ]
                },
                "FAMILIA NEO": {
                    "Image": require("./../assets/panoramas/TVSneoNXFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.511 0 -2.533",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"5.875 0 3.535",
                            "Rotation":"-95.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"4.208 0 -8.111",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"17.832 0 -1.263",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.609 0 -1.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"15.313 4.279 15.859",
                            "Rotation":"0 -180.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA SPORT",
                            "Image": require('./../UI/labels/familia-sport.svg').default
                        },
                        {
                            "Position":"-9.014 3.391 -0.716",
                            "Rotation":"0.000 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Neo NX 110",
                            "Image": require('./../UI/labels/neo-nx.png').default
                        },
                        {
                            "Position":"6.687 4.415 -25.162",
                            "Rotation":"0 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA MOTOCARRO",
                            "Image": require('./../UI/labels/familia-motocarro.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"20.845 -0.270 15.849",
                            "Rotation":"0 -5.979 0",
                            "Scale":"40.569 6.344",
                            "goTo":"FAMILIA SPORT",
                        },
                        {
                            "Position":"-8.719 -1.261 -0.447",
                            "Rotation":"0 -92.570 0",
                            "Scale":"4.437 6.344",
                            "goTo":"Neo NX 110",
                        },
                        {
                            "Position":"9.946 0.022 -25.162",
                            "Rotation":"0 -135.078 0",
                            "Scale":"32.455 6.344",
                            "goTo":"FAMILIA MOTOCARRO",
                        }
                    ]
                },
                "FAMILIA MOTO MES": {
                    "Image": require("./../assets/panoramas/TVSProductoDelMesFamilia.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.511 0 -2.533",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"0.474 0 -4.380",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-2.698 0 7.269",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-7.455 0 -6.423",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.419 0 -1.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES"
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-6.875 4.279 22.007",
                            "Rotation":"0 -180.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA APACHE",
                            "Image": require('./../UI/labels/familia-apache.svg').default
                        },
                        {
                            "Position":"-9.004 5.380 -0.716",
                            "Rotation":"0.000 90.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"MOTO MES",
                            "Image": require('./../UI/labels/raider-125.svg').default
                        },
                        {
                            "Position":"0.416 4.415 -25.162",
                            "Rotation":"0 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA NTORQ",
                            "Image": require('./../UI/labels/familia-ntorq.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-9.126 -0.270 28.185",
                            "Rotation":"0 -5.979 0",
                            "Scale":"40.569 6.344",
                            "goTo":"FAMILIA APACHE",
                        },
                        {
                            "Position":"-8.719 0.621 -0.447",
                            "Rotation":"0 -92.570 0",
                            "Scale":"7.075 6.344",
                            "goTo":"MOTO MES",
                        },
                        {
                            "Position":"1.758 -1.212 -24.139",
                            "Rotation":"0 -172.877 0",
                            "Scale":"21.346 6.344",
                            "goTo":"FAMILIA NTORQ",
                        }
                    ]
                },

                "Neo NX 110": {
                    "Image": require("./../assets/panoramas/NeoNX110_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.668 0 2.261",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.224 0 -3.522",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"3.130 0 7.974",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110 LAT DER"
                        }
                    ]
                },
                "Neo NX 110 LAT IZQ": {
                    "Image": require("./../assets/panoramas/NeoNX110_LateralIzq.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-4.379 0 6.973",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.601 0 5.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.211 0 2.200",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-2.211 0 -1.776",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 POSTERIOR"
                        }
                    ]
                },
                "Neo NX 110 LAT DER": {
                    "Image": require("./../assets/panoramas/NeoNX110_LateralDer.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"1.658 0 -6.314",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.444 0 -12.319",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"6.101 0 -6.155",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.963 0 -2.483",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-1.963 0 2.149",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.083 -2.105",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Sus detalles y líneas modernas cargadas de diseño, hacen de esta moto no solo un excelente producto sino también el complemento ideal a tu imagen. En la Neo NX 110 tienes a tu alcance calcas en colores llamativos diseñadas bajo las ultimas tendencias y sus complementos en estilo carbono te encantarán.",
                            "Image": require("./../assets/bullets/NeoNX/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 0.117 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"La opción ideal para transportarte en la ciudad, tiene un asiento amplio y muy cómodo, su caja de cambios semiautomática (no necesitas manejar clutch) es muy fácil de manejar, además es una moto con una altura ideal para que te detengas cómodamente.",
                            "Image": require("./../assets/bullets/NeoNX/Bullet 03.webp").default
                        },
                        {
                            "Position":"-3.826 -1.473 -0.464",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Moverte por todas partes con tranquilidad es muy importante, por eso la NEO NX es una 110 muy potente, sus 8,6 caballos de potencia son garantía que en plano o en subida esta moto no te decepcionará.",
                            "Image": require("./../assets/bullets/NeoNX/Imagen_descriptiva_atributo_potencia.jpg").default
                        }
                    ]
                },
                "Neo NX 110 POSTERIOR": {
                    "Image": require("./../assets/panoramas/NeoNX110_Posterior.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-9.586 0 -2.706",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.423 0 -7.768",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.361 0 -1.297",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 LAT DER"
                        },
                        {
                            "Position":"-2.361 0 1.070",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Neo NX 110 LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.789 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Como si fuera poco, la Neo NX cuenta con cargador de puerto USB, que te permitirá conducir por la ciudad sin preocuparte de que tu teléfono se descargue.",
                            "Image": require("./../assets/bullets/NeoNX/Bullet 02.webp").default
                        }
                    ]
                },

                "MOTO MES": {
                    "Image": require("./../assets/panoramas/TVSraider_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"6.207 0 2.734",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"START"
                        },
                        {
                            "Position":"-10.917 0 -5.763",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.830 0 -2.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.073 0 -6.671",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-6.770 0 6.656",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"1.789 0 1.860",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -0.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT IZQ"
                        },
                        {
                            "Position":"-2.161 0 3.069",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 2.718 1.061",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tiene una farola led doble módulo , carenaje agresivo, tanque urbano deportivo, stop en led, sillín divido a doble altura y más amplio con una guantera bajo el asiento trasero. Detalles únicos que hacen a la TVS Raider la mejor opción de todas las 125 del mercado.",
                            "Image": require("./../assets/bullets/Raider125/Bullet 01.webp").default
                        }
                    ]
                },
                "MOTO MES LAT IZQ": {
                    "Image":  require("./../assets/panoramas/TVSraider_LateralIzq.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-8.529 0 11.107",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-0.626 0 6.049",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"7.2130 0.647",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.597 0 -12.473",
                            "Rotation":"-85.150 0.000 0.000",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"13.034 0 -8.693",
                            "Rotation":"-85.150 0.000 90.000",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"-5.383 0 -5.601",
                            "Rotation":"-85.150 0.000 90.000",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.907",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES"
                        },
                    ]
                },
                "MOTO MES LAT DER": {
                    "Image":  require("./../assets/panoramas/TVSraider_LateralDer.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-0.026 0 -6.877",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.901 0 -5.121",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.45 0.45",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.712 0 14.398",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"3.044 0 2.482",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES"
                        },
                        {
                            "Position":"-1.662 0 3.033",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"MOTO MES POSTERIOR"
                        }
                    ]
                },
                "MOTO MES POSTERIOR": {
                    "Image":  require("./../assets/panoramas/TVSraider_Posterior.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"-7.303 0 -3.493",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.132 0 2.234",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-1.820 0 9.340",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"6.912 0 14.383",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"11.940 0 9.081",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"3.092 0 -4.287",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.55 0.55",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT DER"
                        },
                        {
                            "Position":"-1.692 0 2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 2.464 -0.047",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"¡El segmento de 125 nunca será el mismo después de la TVS RAIDER! Cuenta con un tablero LCD digital a color como ninguna otra, encendido silencioso y  USB integrado en el tanque, que hacen de esta moto la más innovadora de las 125. Por fin el mercado tiene una moto que cumple con sus expectativas.",
                            "Image": require("./../assets/bullets/Raider125/Bullet 03.webp").default
                        },
                        {
                            "Position":"-3.826 2.093 -0.047",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"12.73 caballos combinados con 11.5 NM de torque hacen de esta 125 la más imponente en performance frente a sus competidoras, sus 5 velocidades y motor de 3 válvulas aseguran que la respuesta de aceleración y potencia siempre estén a la mano.",
                            "Image": require("./../assets/bullets/Raider125/Bullet 02.webp").default
                        }
                    ]
                },

                "Ntorq 125": {
                    "Image": require("./../assets/panoramas/Ntorq125_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"4.668 0 2.261",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-6.032 0 19.271",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"9.891 0 8.680",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-6.352 0 9.744",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-1.065 0 3.024",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"4.571 0 4.556",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 LAT DER"
                        },
                        {
                            "Position":"-2.362 0 2.466",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"-3.859 0 4.570",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi"
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-17.390 3.950 8.988",
                            "Rotation":"0 149.268 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125 Racing",
                            "Image": require('./../UI/labels/ntorq-125-race.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-15.192 -0.119 7.968",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Ntorq 125 Racing",
                        }
                    ]
                },
                "Ntorq 125 LAT IZQ": {
                    "Image": require("./../assets/panoramas/Ntorq125_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-3.421 0 6.085",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-10.512 0 12.660",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-6.379 0 6.955",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.160 0.-0.563",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su motor monocilíndrico de 4 tiempos y sus 9.25 HP tu scooter está lista para desafiar lo que creías conocer sobre potencia. Aprovecha sus características y conquista la ciudad bajo tus propias reglas.",
                            "Image": require("./../assets/bullets/Ntorq125/Tecnologia_potencia_ntorq_125.jpg").default
                        }
                    ]
                },
                "Ntorq 125 LAT DER": {
                    "Image": require("./../assets/panoramas/Ntorq125_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.273 0 -6.312",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"9.990 0 3.724",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"6.552 0 -12.430",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"2.386 0 -6.916",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"1.015 0 -1.470",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 POSTERIOR"
                        }
                    ]
                },
                "Ntorq 125 POSTERIOR": {
                    "Image": require("./../assets/panoramas/Ntorq125_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-9.271 0 2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.013 0 -4.694",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-4.633 0 -3.641",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.370 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Controla cada aspecto de tu scooter Ntorq gracias a su tablero inteligente, en donde encontrarás las estadísticas necesarias para que tu experiencia de viaje sea insuperable.",
                            "Image": require("./../assets/bullets/Ntorq125/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 1.370 -0.257",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Smart X Connect cada viaje en tu scooter será más divertido. Accede al ecosistema de conectividad más completo del mercado con herramientas como telemetría de ruta, identificación de llamadas, navegación asistida entre muchas más. *La característica de alerta de accidentes que hace parte del ecosistema Smart Xconnect actualmente no está disponible en Colombia.",
                            "Image": require("./../assets/bullets/Ntorq125/Tecnologia_conectividad_tvs_ntorq_125.jpg").default
                        },
                        {
                            "Position":"-3.826 0.172 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tu Ntorq 125 te ofrece vibrantes colores y un diseño de ultima generación para que destaques en cada viaje. Escoge tu favorito para empezar una nueva aventura en la ciudad.",
                            "Image": require("./../assets/bullets/Ntorq125/Tecnologia_diseno_tvs_ntorq_125.jpg").default
                        }
                    ]
                },

                "Ntorq 125 Racing": {
                    "Image": require("./../assets/panoramas/Ntorq125Racing_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.166 0 -0.217",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-4.449 0 16.592",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"11.940 0 4.847",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-5.265 0 9.744",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"1.169 0 0.153",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"6.198 0 1.323",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing LAT DER"
                        },
                        {
                            "Position":"-2.362 0 2.355",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi"
                        },
                        {
                            "Position":"1.038 0 -2.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.281 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Inspirada en el ADN de carreras que caracteriza a TVS, contarás con un diseño deportivo inigualable que te hará destacar en la ciudad. Siente en cada viaje el diseño y desempeño que acompaña al equipo TVS Racing en las pistas de competencia alrededor del mundo.",
                            "Image": require("./../assets/bullets/Ntorq125RaceEdition/Bullet 02.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-15.641 3.982 8.860",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125 fi",
                            "Image": require('./../UI/labels/ntorq-125-fi.png').default
                        },
                        {
                            "Position":"-6.816 3.929 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125",
                            "Image": require('./../UI/labels/ntorq.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-15.192 -0.119 7.968",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Ntorq 125 fi",
                        },
                        {
                            "Position":"-5.204 -1.063 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Ntorq 125",
                        }
                    ]
                },
                "Ntorq 125 Racing LAT IZQ": {
                    "Image": require("./../assets/panoramas/Ntorq125Racing_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.577 0 9.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.014 0 9.759",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.302 -0.605",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su motor monocilíndrico de 4 tiempos y sus 9.25 HP tu scooter está lista para desafiar lo que creías conocer sobre potencia. Aprovecha sus características y conquista la ciudad bajo tus propias reglas.",
                            "Image": require("./../assets/bullets/Ntorq125RaceEdition/Tecnologia_potencia_tvs_ntorq_racing.jpg").default
                        }
                    ]
                },
                "Ntorq 125 Racing LAT DER": {
                    "Image": require("./../assets/panoramas/Ntorq125Racing_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-4.639 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"8.617 0 2.359",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-0.433 0 -8.702",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-2.035 0 -4.754",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing POSTERIOR"
                        }
                    ]
                },
                "Ntorq 125 Racing POSTERIOR": {
                    "Image": require("./../assets/panoramas/Ntorq125Racing_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-9.271 0 2.088",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 Racing LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.370 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Controla cada aspecto de tu scooter Ntorq 125 Race Edition gracias a su tablero inteligente, en donde encontrarás las estadísticas necesarias para que tu experiencia de viaje sea insuperable.",
                            "Image": require("./../assets/bullets/Ntorq125RaceEdition/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 1.370 -0.311",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con la tecnología Smart XConnect de tu Ntorq 125 Race Edition, obtén la combinación ideal entre tecnología y velocidad. Accede al ecosistema de conectividad mas completo del mercado con herramientas como: identificación de llamadas y navegación asistida.",
                            "Image": require("./../assets/bullets/Ntorq125RaceEdition/Tecnologia_conectividad_tvs_ntorq_racing.jpg").default
                        }
                    ]
                },

                "Ntorq 125 fi": {
                    "Image": require("./../assets/panoramas/Ntorq125FI_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.156 0 -2.862",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-3.530 0 16.592",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.450 0 8.863",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"2.425 0 -1.970",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"7.387 0 -0.232",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 fi LAT DER"
                        },
                        {
                            "Position":"1.069 0 -2.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125 Racing"
                        },
                        {
                            "Position":"3.186 0 -3.966",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Ntorq 125"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.177 0.714",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Ultima tecnologia en aceleración: impulsada por la tecnología Race Tuned Fuel Injection (RT-FI) que permite disfrutar de una aceleración instantánea con una mayor entrega de potencia, mejora la durabilidad del motor ",
                            "Image": require("./../assets/bullets/Ntorq125FI/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 0.562 -0.151",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Inspirada en el ADN de carreras que caracteriza a TVS, contarás con un diseño deportivo inigualable que te hará destacar en la ciudad. Siente en cada viaje el diseño y desempeño que acompaña al equipo TVS Racing en las pistas de competencia alrededor del mundo.",
                            "Image": require("./../assets/bullets/Ntorq125FI/02_DESINO_VANGUARDIA.jpg").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-6.167 3.483 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Ntorq 125 Racing",
                            "Image": require('./../UI/labels/ntorq-125-race.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-4.458 -1.572 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Ntorq 125 Racing",
                        }
                    ]
                },
                "Ntorq 125 fi LAT IZQ": {
                    "Image": require("./../assets/panoramas/Ntorq125FI_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"3.404 0 9.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.127 0 10.499",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.233 -0.484",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su motor monocilíndrico de 4 tiempos y sus 9.25 HP tu scooter está lista para desafiar lo que creías conocer sobre potencia. Aprovecha sus características y conquista la ciudad bajo tus propias reglas.",
                            "Image": require("./../assets/bullets/Ntorq125FI/04_ARRANQUE.jpg").default
                        }
                    ]
                },
                "Ntorq 125 fi LAT DER": {
                    "Image": require("./../assets/panoramas/Ntorq125FI_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-4.639 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-4.639 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"8.617 0 1.672",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-1.771 0 -8.540",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-3.447 0 -5.034",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"17.101 0 1.672",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"17.101 0 -5.670",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi POSTERIOR"
                        }
                    ]
                },
                "Ntorq 125 fi POSTERIOR": {
                    "Image": require("./../assets/panoramas/Ntorq125FI_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-12.270 0 3.452",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-2.958 0 -12.768",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Ntorq 125 fi LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.393 -0.027",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con la tecnología Smart X Connect de tu Ntorq 125 Race Edition, obtén la combinación ideal entre tecnología y velocidad. Accede al ecosistema de conectividad mas completo del mercado con herramientas como: identificación de llamadas y navegación asistida. *La característica de alerta de accidentes que hace parte del ecosistema Smart X Connect actualmente no está disponible en Colombia. *Esta información obedece a un comparativo de las motocicletas deportivas vendidas en Colombia entre 160 cc y 200 cc a 17 de marzo de 2021.",
                            "Image": require("./../assets/bullets/Ntorq125FI/03_SMART_X_CONNECT.jpg").default
                        }
                    ]
                },

                "Sport 100 KLS": {
                    "Image": require("./../assets/panoramas/SportKLS_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"7.027 0 0.094",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.387 0 4.566",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"3.558 0 -5.191",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"12.261 0 -0.621",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"11.436 0 12.977",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS LAT DER"
                        },
                        {
                            "Position":"-0.468 0 3.430",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"0.540 0 6.172",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"1.126 0 9.037",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS"
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-7.351 3.429 12.341",
                            "Rotation":"0 -180.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Stryker",
                            "Image": require('./../UI/labels/stryker-125.png').default
                        },
                        {
                            "Position":"6.886 3.483 -18.055",
                            "Rotation":"0.000 -21.178 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Neo NX 110",
                            "Image": require('./../UI/labels/neo-nx.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-7.216 -1.054 9.945",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Stryker",
                        },
                        {
                            "Position":"5.473 0.621 -14.203",
                            "Rotation":"0 -45 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Neo NX 110",
                        }
                    ]
                },
                "Sport 100 KLS LAT IZQ": {
                    "Image": require("./../assets/panoramas/SportKLS_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.661 0 9.007",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-1.185 0 15.046",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-4.825 0 5.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.45 0.45",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-11.266 0 15.968",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS"
                        },
                    ]
                },
                "Sport 100 KLS LAT DER": {
                    "Image": require("./../assets/panoramas/SportKLS_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.311 0 -7.905",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.937 0 -6.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-2.033 0 -15.651",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"3.230 0 -6.702",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.809 -0.252",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"DURALIFE: Esta tecnología hace al motor más durable, muy eficiente en su consumo de combustible y garantiza una entrega de potencia más constante.",
                            "Image": require("./../assets/bullets/Sport100KLS/Bullet01.webp").default
                        },
                        {
                            "Position":"-3.826 -1.043 -1.662",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"SBT Sistema de frenado conjunto, activa el freno delantero y trasero simultáneamente para mejorar la eficiencia y seguridad en el frenado.",
                            "Image": require("./../assets/bullets/Sport100KLS/Bullet02.webp").default
                        },
                        {
                            "Position":"-3.826 0.041 0.866",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Sillin Extra largo: Su silla más larga y ancha provee una mayor comodidad para las largas jornadas de trabajo tanto para el piloto como para el pasajero.",
                            "Image": require("./../assets/bullets/Sport100KLS/Bullet03.webp").default
                        }
                    ]
                },
                "Sport 100 KLS POSTERIOR": {
                    "Image": require("./../assets/panoramas/SportKLS_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-14.016 0 -0.683",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.261 0 -4.683",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 KLS LAT IZQ"
                        }
                    ]
                },

                "Stryker": {
                    "Image": require("./../assets/panoramas/Stryker_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.156 0 -1.215",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.224 0 1.296",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"5.127 0 -6.888",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"13.366 0 -0.350",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"9.797 0 13.676",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker LAT DER"
                        },
                        {
                            "Position":"-1.010 0 -3.375",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-0.691 0 2.867",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"-0.913 0 6.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 0.426",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Diseño y Estilo: Su farola de corte agresivo, los flaps deportivos, sus colores impactantes y los hand savers, son la mezcla perfecta para un vehículo que no solo te transportará, si no que te hará resaltar.",
                            "Image": require("./../assets/bullets/Stryker125/Bullet 01.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-10.563 3.429 12.341",
                            "Rotation":"0 -180.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Max 125",
                            "Image": require('./../UI/labels/max-125.png').default
                        },
                        {
                            "Position":"-10.643 3.483 -14.986",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Sport 100 KLS",
                            "Image": require('./../UI/labels/sport-100-kls.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-9.451 -1.054 9.945",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Max 125",
                        },
                        {
                            "Position":"-7.237 -0.011 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Sport 100 KLS",
                        }
                    ]
                },
                "Stryker LAT IZQ": {
                    "Image": require("./../assets/panoramas/Stryker_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.753 0 7.878",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-1.134 0 16.017",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"5.822 0 7.491",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-5.075 0 4.150",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-13.428 0 11.203",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker"
                        },
                    ]
                },
                "Stryker LAT DER": {
                    "Image": require("./../assets/panoramas/Stryker_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.465 0 -8.025",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.185 0 -17.405",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-0.205 0 -3.448",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-9.347 0 -7.430",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"11.672 0 -12.390",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.092 -0.295",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":" Tecnología EcoThrust que utiliza un pistón revestido del tipo “MolyCoat” que reduce la fricción dentro del cilindro, lo cual aumenta la potencia y logra una combustión más eficiente.",
                            "Image": require("./../assets/bullets/Stryker125/Bullet 03.webp").default
                        }
                    ]
                },
                "Stryker POSTERIOR": {
                    "Image": require("./../assets/panoramas/Stryker_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-10.884 0 3.564",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-6.454 0 -2.985",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-9.725 0 7.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Stryker LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.114",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tablero 100% digital, mejora la visibilidad de los indicadores y complementa de manera perfecta el sentido de modernidad que el diseño de la moto entrega.",
                            "Image": require("./../assets/bullets/Stryker125/Bullet 02.webp").default
                        }
                    ]
                },

                "Max 125": {
                    "Image": require("./../assets/panoramas/Max125_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"7.338 0 -1.271",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.820 0 -2.405",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"5.000 0 -9.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"13.928 0 1.258",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"9.189 0 12.861",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125 LAT DER"
                        },
                        {
                            "Position":"-0.311 0 -6.157",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"-0.961 0 -2.773",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-1.522 0 3.541",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.789 0.025",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Farola Delantera: Goza de una potencia extra que te permitirá rodar con mayor seguridad en esos caminos difíciles y poco iluminados de nuestra geografía.",
                            "Image": require("./../assets/bullets/Max125/Bullet 03.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-10.563 3.429 12.341",
                            "Rotation":"0 -180.000 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Sport 100 ELS",
                            "Image": require('./../UI/labels/sport-100-els.png').default
                        },
                        {
                            "Position":"-11.503 3.483 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Stryker",
                            "Image": require('./../UI/labels/stryker-125.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-9.451 -1.054 9.945",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Sport 100 ELS",
                        },
                        {
                            "Position":"-8.873 -0.011 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Stryker",
                        }
                    ]
                },
                "Max 125 LAT IZQ": {
                    "Image": require("./../assets/panoramas/Max125_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"1.028 0 12.342",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-0.064 0 5.455",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-13.340 0 11.361",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-0.371 0 15.605",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.803 0 8.262",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.550 0.244",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Su tanque de combustible tiene una capacidad de 3,96 galones (15 Litros)",
                            "Image": require("./../assets/bullets/Max125/Bullet 04.webp").default
                        }
                    ]
                },
                "Max 125 LAT DER": {
                    "Image": require("./../assets/panoramas/Max125_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-3.188 0 -9.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.990 -15.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-4.239 0 -3.448",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-10.699 0 -7.777",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.350 1.478",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Sillín a tu altura: Una moto con la altura sillín piso mas baja del segmento, lo que te permite maniobrar con facilidad en terrenos difíciles.",
                            "Image": require("./../assets/bullets/Max125/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 -0.844 -0.438",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Motor: produce una potencia de 10,86 HP @ 8000 RPM, una de las motos tipo doble propósito mas versátiles del mercado,",
                            "Image": require("./../assets/bullets/Max125/Bullet 02.webp").default
                        }
                    ]
                },
                "Max 125 POSTERIOR": {
                    "Image": require("./../assets/panoramas/Max125_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-15.280 0 4.598",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.395 0 2.199",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Max 125 LAT IZQ"
                        }
                    ]
                },

                "Sport 100 ELS": {
                    "Image": require("./../assets/panoramas/SportELS_Frente.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"7.338 0 -3.816",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.820 0 -4.191",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"5.580 0 -10.407",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"13.928 0 -2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.639 0 8.999",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.223",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.112",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 ELS LAT DER"
                        },
                        {
                            "Position":"0.639 0 -9.158",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Sport 100 KLS"
                        },
                        {
                            "Position":"0.144 0 -5.855",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Stryker"
                        },
                        {
                            "Position":"-0.301 0 -3.204",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Max 125"
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-8.180 3.483 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Max 125",
                            "Image": require('./../UI/labels/max-125.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-5.477 -0.011 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Max 125",
                        }
                    ]
                },
                "Sport 100 ELS LAT IZQ": {
                    "Image": require("./../assets/panoramas/SportELS_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"1.028 0 12.342",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.822 0 5.455",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-11.288 0 10.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS"
                        },
                    ]
                },
                "Sport 100 ELS LAT DER": {
                    "Image": require("./../assets/panoramas/SportELS_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-3.188 0 -9.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.092 0 -15.248",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-5.609 0 -5.217",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-11.224 0 -8.089",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -1.053 -2.077",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"SBT Sistema de frenado conjunto, activa el freno delantero y trasero simultáneamente para mejorar la eficiencia y seguridad en el frenado.",
                            "Image": require("./../assets/bullets/Sport100ELS/Bullet03.webp").default
                        },
                        {
                            "Position":"-3.826 -1.053 -0.432",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"DURALIFE: Esta tecnología hace al motor más durable, muy eficiente en su consumo de combustible y garantiza una entrega de potencia más constante.",
                            "Image": require("./../assets/bullets/Sport100ELS/Bullet01.webp").default
                        }
                    ]
                },
                "Sport 100 ELS POSTERIOR": {
                    "Image": require("./../assets/panoramas/SportELS_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-15.280 0 4.598",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-7.395 0 2.199",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA SPORT"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.692 0 -1.142",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS LAT DER"
                        },
                        {
                            "Position":"-1.723 0 1.315",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Sport 100 ELS LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.779 0.052",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Encendido Electrico: Fácil y cómoda de conducir, pensada en hacerte más fácil todas las labores del día a día",
                            "Image": require("./../assets/bullets/Sport100ELS/Bullet02.webp").default
                        }
                    ]
                },

                "Raider 125": {
                    "Image": require("./../assets/panoramas/TVSraider_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"6.207 0 2.734",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"START"
                        },
                        {
                            "Position":"-10.917 0 -5.763",
                            "Rotation":"-95.000 -90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.830 0 -2.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-5.073 0 -6.671",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-6.770 0 6.656",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"1.789 0 1.860",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -0.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT IZQ"
                        },
                        {
                            "Position":"-2.161 0 3.069",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES LAT DER"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 2.718 1.061",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tiene una farola led doble módulo , carenaje agresivo, tanque urbano deportivo, stop en led, sillín divido a doble altura y más amplio con una guantera bajo el asiento trasero. Detalles únicos que hacen a la TVS Raider la mejor opción de todas las 125 del mercado.",
                            "Image": require("./../assets/bullets/Raider125/Bullet 01.webp").default
                        }
                    ]
                },

                "Apache 160 2V": {
                    "Image": require("./../assets/panoramas/RTR1602V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"5.021 0 7.550",
                            "Rotation":"-84.060 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"11.588 0 3.209",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"MOTO MES"
                        },
                        {
                            "Position":"8.726 0 10.585",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"7.194 0 1.243",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.131",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 0.984",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V LAT DER"
                        },
                        {
                            "Position":"-0.450 0 -2.602",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"0.538 0 -5.566",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"1.845 0 -6.099",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"4.443 0 -5.893",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"7.138 0 -5.546",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 0.426",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a su freno de disco delantero , la Apache RTR 160 2V te permite reaccionar de manera correcta ante cualquier inconveniente que se presente en la vía.",
                            "Image": require("./../assets/bullets/Apache160_2V/BASE_TECNOLOGIA_160__2V_BANNER_01.jpg").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-11.202 4.011 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 160 4V",
                            "Image": require('./../UI/labels/rtr-160-4v.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-8.504 -0.862 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Apache 160 4V",
                        }
                    ]
                },
                "Apache 160 2V LAT IZQ": {
                    "Image": require("./../assets/panoramas/RTR1602V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-12.928 0 7.413",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[

                        {
                            "Position":"-10.458 0 9.170",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.413 0.426",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Los 13.9 caballos de fuerza que ofrece la Apache RTR 160 2V te harán tener toda la potencia que necesitas en el asfalto.",
                            "Image": require("./../assets/bullets/Apache160_2V/001_BANNER_TECNOLOGIA_POTENCIA_BANNER_01.jpg").default
                        }
                    ]
                },
                "Apache 160 2V LAT DER": {
                    "Image": require("./../assets/panoramas/RTR1602V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"8.032 0 -5.211",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"7.065 0 -8.975",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-1.038 0 -6.696",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"10.252 0 -10.857",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.413 -0.749",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Su motor de 4 tiempos monocilíndrico, responde rápidamente a tus necesidades de transporte en el día a día.",
                            "Image": require("./../assets/bullets/Apache160_2V/003_BANNER_TECNOLOGIA_MOTOR_BANNER_01.jpg").default
                        },
                        {
                            "Position":"-3.826 -0.413 -1.811",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a su freno de disco delantero , la Apache RTR 160 2V te permite reaccionar de manera correcta ante cualquier inconveniente que se presente en la vía.",
                            "Image": require("./../assets/bullets/Apache160_2V/002_BANNER_TECNOLOGIA_DISCO_BANNER_01.jpg").default
                        }
                    ]
                },
                "Apache 160 2V POSTERIOR": {
                    "Image": require("./../assets/panoramas/RTR1602V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-5.857 0 -11.026",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-9.895 0 -7.577",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.141",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.091",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 2V LAT IZQ"
                        }
                    ]
                },

                "Apache 160 4V": {
                    "Image": require("./../assets/panoramas/RTR1604V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"2.685 0 10.466",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"18.321 0 -5.228",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"9.583 0 12.632",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"4.400 0 2.118",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.398",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.283",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V LAT DER"
                        },
                        {
                            "Position":"-0.450 0 2.548",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"0.384 0 -3.169",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"1.768 0 -4.377",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"3.728 0 -4.443",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"5.326 0 -3.785",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.117",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Renovación total de look y agresividad en su diseño con esta nueva farola LED, que incluye en sus caracteristicas luces tipo “CLAW” inspiradas en las motos de alta gama",
                            "Image": require("./../assets/bullets/Apache160_4V/BASE_TECNOLOGIA_RT_160_4V_FAROLA_01_01.jpg").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-8.512 3.982 8.860",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 160 4V",
                            "Image": require('./../UI/labels/rtr-160-4v.png').default
                        },
                        {
                            "Position":"-6.816 3.929 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 180 2V",
                            "Image": require('./../UI/labels/rtr-180-2v.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-7.882 -0.905 7.968",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Apache 160 4V",
                        },
                        {
                            "Position":"-5.204 -1.063 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Apache 180 2V",
                        }
                    ]
                },
                "Apache 160 4V LAT IZQ": {
                    "Image": require("./../assets/panoramas/RTR1604V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-10.777 0 7.935",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[

                        {
                            "Position":"-6.660 0 9.008",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.001 0.545",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"La Nueva Apache RTR 160 4V 2022 es la moto con la que redefiniremos el mercado del segmento medio deportivo en Colombia. Su cilindrada es la más potente frente a todas sus competidoras con unos impresionantes 16.2HP que la ponen muy por encima de cualquier modelo que la quiera igualar en potencia.",
                            "Image": require("./../assets/bullets/Apache160_4V/BASE_TECNOLOGIA_POTENCIA_160_4V_BANNER_01.jpg").default
                        }
                    ]
                },
                "Apache 160 4V LAT DER": {
                    "Image": require("./../assets/panoramas/RTR1604V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.280 0 -6.934",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"0.645 0 -7.335",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.385 -0.811",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Su ingeniería superior trae nuevos elementos nunca antes vistos en este tipo de motocicletas. La nueva Apache 160 4V es pionera y la única 160 de todo su segmento en tener este tipo de tecnologías que mejoran el desempeño y dan mayor seguridad a su usuario.",
                            "Image": require("./../assets/bullets/Apache160_4V/BASE_TECNOLOGIA_RT_160_4V_BANNER_01.jpg").default
                        }
                    ]
                },
                "Apache 160 4V POSTERIOR": {
                    "Image": require("./../assets/panoramas/RTR1604V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-8.944 0 -13.564",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-11.256 0 -3.144",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.206",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.179",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 160 4V LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 0.092",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Ya no es suficiente que las motos tengan potencia, ahora la verdadera experiencia de innovación la llevamos al siguiente nivel con la tecnología Smart Xconnect. Con la Nueva Apache 160 4V 2022 disfruta de una de las motos con mayor ecosistema de conectividad en el mercado.",
                            "Image": require("./../assets/bullets/Apache160_4V/BASE_TECNOLOGIA_SMART_160_4V_BANNER_01_01.jpg").default
                        }
                    ]
                },

                "Apache 200 fi": {
                    "Image": require("./../assets/panoramas/RTR200FI_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"10.481 0 -1.743",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"11.982 0 -4.903",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"5.990 0 -3.401",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.487",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.487",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi LAT DER"
                        },
                        {
                            "Position":"7.166 0 3.549",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"4.223 0 3.951",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"1.369 0 3.199",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"0.254 0 2.550",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-0.879 0 -2.617",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.221",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Modos de Manejo: Los 3 modos de manejo sport, urbano y lluvia le dan al piloto el poder de adaptarse a cualquier condición de camino al alcance de un botón.",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/Bullet 04.webp").default
                        },
                        {
                            "Position":"-3.826 1.386 0.777",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Ultima Tecnologia en Aceleración: Está impulsada por la tecnología Race Tuned Fuel Injection (RT-FI) que permite disfrutar de una aceleración instantánea con una mayor entrega de potencia, mejora la durabilidad del motor.  ",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/Bullet 02.webp").default
                        },
                        {
                            "Position":"-3.826 1.386 -0.662",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Levas de freno y embrague ajustables, primeras de su clase y diseñadas ergonómicamente, te permiten ajustar tu conducción en tres niveles distintos (con ajustadores CAM) de fácil acción, características del universo Racing que te otorgan un confort hecho a la medida.",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/levas_ajustables.png").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-5.139 3.982 10.231",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 2V",
                            "Image": require('./../UI/labels/rtr-200-4v.png').default
                        },
                        {
                            "Position":"-12.157 3.929 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache RR 310",
                            "Image": require('./../UI/labels/rr-310.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-3.972 -0.905 8.017",
                            "Rotation":"0 -5.979 0",
                            "Scale":"7.323 6.344",
                            "goTo":"Apache 200 2V",
                        },
                        {
                            "Position":"-9.137 -0.305 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"5.888 5.234",
                            "goTo":"Apache RR 310",
                        }
                    ]
                },
                "Apache 200 fi LAT IZQ": {
                    "Image": require("./../assets/panoramas/RTR 200 FI_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.309 0 14.582",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.847 0 8.292",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi"
                        },
                    ]
                },
                "Apache 200 fi LAT DER": {
                    "Image": require("./../assets/panoramas/RTR200FI_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-2.900 0 -16.011",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-6.626 0 -14.876",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.7 0.7",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-5.180 0 -9.076",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"-1.914 0 1.708",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.128 -1.767",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Frenos ABS, Permite un frenado superior con retroalimentación precisa y recuperación del bloqueo de las ruedas. ",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/Bullet 01.webp").default
                        },
                        {
                            "Position":"-3.826 0.748 -1.429",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Un corredor debe adaptar su enfoque a cualquier terreno y las suspensiones ajustables SHOWA, primeras en su clase, lo permiten. La precarga se puede ajustar entre suave para una conducción cómoda, o rígida para un estilo de manejo agresivo y dominar las carreteras.",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/suspensiones_showa.png").default
                        },
                        {
                            "Position":"-3.826 -0.521 -0.714",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con esta tecnología obtendrás mayor seguridad y desempeño en el momento de bajar marchas o maniobrar curvas. ¡Controla la inercia de la moto y aprovecha al máximo sus propiedades deportivas previniendo bloqueos de llantas y riesgos innecesarios!",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/RT_slipper_clutch.png").default
                        }
                    ]
                },
                "Apache 200 fi POSTERIOR": {
                    "Image": require("./../assets/panoramas/RTR200FI_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-14.640 0 -6.563",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.351",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.351",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 fi LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.354 0.062",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"SmartXconnect Technology,podrás unir tu celular con tu motocicleta y tener a tu disposición el más completo ecosistema de herramientas para disfrutar cada viaje: telemetría de carrera, sensor de inclinación, asistencia de navegación, entre otros",
                            "Image": require("./../assets/bullets/Apache2004VFIABS/BUllet 03.webp").default
                        }
                    ]
                },

                "Apache 180 2V": {
                    "Image": require("./../assets/panoramas/RTR1802V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"4.574 0 11.846",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"7.633 0 11.954",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"6.068 0 4.040",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.285",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.285",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V LAT DER"
                        },
                        {
                            "Position":"-0.856 0 5.570",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"-1.569 0 3.265",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"0.088 0 -1.249",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"2.950 0 -2.301",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"5.223 0 -2.245",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.156 -0.186",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"El diseño de la farola de la Apache RTR 180, está inspirado en cortes aerodinámicos, que dan a la moto un estilo agresivo, deportivo y moderno; por eso, es potencia y estilo para el día a día.",
                            "Image": require("./../assets/bullets/Apache180_2V/Bullet 2.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-8.512 3.982 8.860",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 160 4V",
                            "Image": require('./../UI/labels/rtr-160-4v.png').default
                        },
                        {
                            "Position":"-3.686 3.929 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 2V",
                            "Image": require('./../UI/labels/rtr-200-4v.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-7.882 -0.905 7.968",
                            "Rotation":"0 -5.979 0",
                            "Scale":"7.323 6.344",
                            "goTo":"Apache 160 4V",
                        },
                        {
                            "Position":"-2.655 -1.561 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Apache 200 2V",
                        }
                    ]
                },
                "Apache 180 2V LAT IZQ": {
                    "Image": require("./../assets/panoramas/RTR1802V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-12.958 0 7.484",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-5.022 0 9.404",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.291 1.705",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Gracias a su sistema de doble freno de disco, la Apache RTR 180 2V te permite reaccionar de manera correcta ante cualquier inconveniente que se presente en la vía.",
                            "Image": require("./../assets/bullets/Apache180_2V/Bullet 1.webp").default
                        },
                        {
                            "Position":"-3.826 -0.291 0.379",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Los 15.02 caballos de fuerza quLos 15.02 caballos de fuerza que ofrece la Apache RTR 180 2V te harán tener toda la potencia que necesitas para recorrer las calles.e ofrece la Apache RTR 180 2V te harán tener toda la potencia que necesitas para recorrer las calles.",
                            "Image": require("./../assets/bullets/Apache180_2V/BANNER_180_2V_TECNOLOGIA_POTENCIA_01.jpg").default
                        }
                    ]
                },
                "Apache 180 2V LAT DER": {
                    "Image": require("./../assets/panoramas/RTR1802V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"11.738 0 -7.696",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"2.773 0 -8.546",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.495 -1.742",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Tu Apache RTR 180 2V tiene la tecnología necesaria para cumplir con los desafíos más exigentes.",
                            "Image": require("./../assets/bullets/Apache180_2V/BASE_TECNOLOGIA_160__2V_BANNER_01_01.jpg").default
                        }
                    ]
                },
                "Apache 180 2V POSTERIOR": {
                    "Image": require("./../assets/panoramas/RTR1802V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-9.042 0 -10.988",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.149",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.145",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 180 2V LAT IZQ"
                        }
                    ]
                },

                "Apache RR 310": {
                    "Image": require("./../assets/panoramas/RR310_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"13.354 0 -0.316",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"13.223 0 -2.945",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"5.126 0 -0.491",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.463",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310 LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.463",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310 LAT DER"
                        },
                        {
                            "Position":"7.022 0 5.482",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"4.639 0 5.974",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"1.774 0 6.300",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"0.664 0 5.262",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-0.571 0 2.702",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.386 0.777",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a su acelerador electrónico que reemplaza el sistema mecánico tradicional, tendrás más control en cada viaje. Disfruta del dominio total en cada acelerada y aprovecha el combustible al máximo",
                            "Image": require("./../assets/bullets/ApacheRR310/BASE_TECNOLOGIA_RR_310_ACELERADOR_01.jpg").default
                        },
                        {
                            "Position":"-3.826 1.087 -0.185",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Urban, Track, Sport & Rain, disfruta de cuatro modos de conducción diferentes y establece tus propias reglas en el camino con tu Apache RR 310.",
                            "Image": require("./../assets/bullets/ApacheRR310/BASE_TECNOLOGIA_RR_310_MANEJO_01.jpg").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-9.012 3.982 10.231",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 fi",
                            "Image": require('./../UI/labels/rtr-200-4v-fi.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-7.612 -0.905 8.017",
                            "Rotation":"0 -5.979 0",
                            "Scale":"7.323 6.344",
                            "goTo":"Apache 200 fi",
                        }
                    ]
                },
                "Apache RR 310 LAT IZQ": {
                    "Image": require("./../assets/panoramas/RR310_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-1.025 0 14.564",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-0.335 0 5.605",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310"
                        },
                    ]
                },
                "Apache RR 310 LAT DER": {
                    "Image": require("./../assets/panoramas/RR310_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.334 0 -14.281",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-2.487 0 -7.593",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 POSTERIOR"
                        }
                    ]
                },
                "Apache RR 310 POSTERIOR": {
                    "Image": require("./../assets/panoramas/RR310_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.162",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.162",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache RR 310 LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.386 0.329",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Tu RR 310 cuenta con un tablero digital de última generación en donde tendrás a tu alcance todas las estadisticas asociadas de tu moto. ¡En cada viaje tendrás el control total de lo que pasa mientras ruedas! ",
                            "Image": require("./../assets/bullets/ApacheRR310/BASE_TECNOLOGIA_RR_310_TABLERO_RACING_01.jpg").default
                        },
                        {
                            "Position":"-3.826 1.386 -0.174",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con la poderosa tecnología Smart X Connect podras unir tu celular a tu motocicleta y tener a tu disposición el más completo ecosistema de herramientas para disfrutar cada viaje: telemetría de carrera, contestación de llamadas, asistencia en navegación entre otras. *La característica de alerta de accidentes que hace parte del ecosistema Smart Xconnect actualmente no está disponible en Colombia.",
                            "Image": require("./../assets/bullets/ApacheRR310/BASE_TECNOLOGIA_RR_310_SMART_01.jpg").default
                        }
                    ]
                },

                "Apache 200 2V": {
                    "Image": require("./../assets/panoramas/RTR2004V_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"13.713 0 1.703",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"12.870 0 -0.944",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"5.626 0 -1.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.485",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.472",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 2V LAT DER"
                        },
                        {
                            "Position":"4.460 0 3.971",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 2V"
                        },
                        {
                            "Position":"1.829 0 3.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 160 4V"
                        },
                        {
                            "Position":"-0.586 0 1.357",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 180 2V"
                        },
                        {
                            "Position":"-0.623 0 -2.800",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache 200 fi"
                        },
                        {
                            "Position":"0.655 0 -4.889",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Apache RR 310"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.100 0.020",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Renovación total de look y agresividad en su diseño con esta nueva farola LED, que incluye en sus caracteristicas luces tipo “CLAW” inspiradas en las motos de alta gama",
                            "Image": require("./../assets/bullets/Apache2004V/Bullet 03.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-5.139 3.982 10.231",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 180 2V",
                            "Image": require('./../UI/labels/rtr-180-2v.png').default
                        },
                        {
                            "Position":"-8.431 3.929 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Apache 200 fi",
                            "Image": require('./../UI/labels/rtr-200-4v-fi.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-3.972 -0.905 8.017",
                            "Rotation":"0 -5.979 0",
                            "Scale":"7.323 6.344",
                            "goTo":"Apache 180 2V",
                        },
                        {
                            "Position":"-6.048 -0.305 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"5.888 5.234",
                            "goTo":"Apache 200 fi",
                        }
                    ]
                },
                "Apache 200 2V LAT IZQ": {
                    "Image": require("./../assets/panoramas/RTR2004V_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-4.3718 0 14.646",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"0.247 0 8.553",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-0.571 0 17.369",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.442 0 -2.166",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.495 -1.742",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Con esta tecnología obtendrás mayor seguridad y desempeño en el momento de bajar marchas o maniobrar curvas. ¡Controla la inercia de la moto y aprovecha al máximo sus propiedades deportivas preveniendo bloqueos de llantas y riesgos innecesarios!",
                            "Image": require("./../assets/bullets/Apache2004V/200_4V_TECNOLOGIA_RT_01.jpg").default
                        }
                    ]
                },
                "Apache 200 2V LAT DER": {
                    "Image": require("./../assets/panoramas/RTR2004V_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-0.626 0 -14.105",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-4.107 0 -9.256",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"-2.654 0 -14.855",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.948 -0.259",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Su ingeniería superior te ofrece la única 200 CC en su categoría con tecnología Slipper Clutch que te entrega mayor seguridad y desempeño en su manejo.",
                            "Image": require("./../assets/bullets/Apache2004V/200_4V_TECNOLOGIA_INGENIERA_SUPERIOR_01.jpg").default
                        }
                    ]
                },
                "Apache 200 2V POSTERIOR": {
                    "Image": require("./../assets/panoramas/RTR2004V_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[

                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.008",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V LAT DER"
                        },
                        {
                            "Position":"-2.219 0 1.008",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Apache 200 2V LAT IZQ"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.264 0.038",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":"Con la Nueva Apache 200 4V 2022 disfrutarás de la exclusiva tecnología Smart Xconnect, un novedoso ecosistema de conexión que te da acceso total a tu moto: navegación punto a punto, telemetría en ruta, y muchos beneficios más. *La característica de alerta de accidentes que hace parte del ecosistema Smart Xconnect actualmente no está disponible en Colombia.",
                            "Image": require("./../assets/bullets/Apache2004V/200_4V_TECNOLOGIA_SMART_01.jpg").default
                        }
                    ]
                },

                "Motocarro King Basico": {
                    "Image": require("./../assets/panoramas/MTbasico_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"9.877 0 -3.018",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-3.999 0 12.505",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.815 0 -1.351",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"12.640 0 7.957",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"6.083 0 -3.770",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"-0.883 0 14.710",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-8.003 0 13.001",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Neo NX 110"
                        },
                        {
                            "Position":"-1.599 0 4.535",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -1.458",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Basico LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 1.680",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Basico LAT DER"
                        },
                        {
                            "Position":"-3.934 0 3.419",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                        {
                            "Position":"-6.092 0 6.239",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.708 -0.046",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su versatilidad y adaptabilidad a diversos terrenos, el TVS King está listo para acompañarte en tus jornadas de trabajo sin importar a donde vayas. Con este motocarro no te quedarás atrás.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 03.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-22.816 4.803 12.341",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Carpa Especial",
                            "Image": require('./../UI/labels/king-especial.png').default
                        },
                        {
                            "Position":"7.812 4.290 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"FAMILIA NTORQ",
                            "Image": require('./../UI/labels/familia-ntorq.svg').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-17.160 -0.119 7.968",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Motocarro King Carpa Especial",
                        },
                        {
                            "Position":"5.482 -0.011 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"FAMILIA NTORQ",
                        }
                    ]
                    
                },
                "Motocarro King Basico LAT IZQ": {
                    "Image": require("./../assets/panoramas/MTbasico_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"8.101 0 9.585",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"5.361 0 11.463",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-4.584 0 -2.970",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico POSTERIOR"
                        },
                        {
                            "Position":"-2.442 0 2.753",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.699 -1.438",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Duralife patentada por TVS podrás disfrutar de muchas horas de manejo con un gasto mínimo de combustible. ¡Este motocarro es el aliado perfecto a la hora de ahorrar!",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 01.webp").default
                        }
                    ]
                },
                "Motocarro King Basico LAT DER": {
                    "Image": require("./../assets/panoramas/MTbasico_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-1.545 0 -14.105",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"1.524 0 -11.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"-2.558 0 -10.246",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"12.140 0 3.825",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"2.609 0 0.456",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.783 0 9.147",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico"
                        },
                        {
                            "Position":"-3.456 0 3.267",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.455 1.731",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con el motocarro TVS King tendrás a tu alcance un vehículo práctico, versátil y muy duradero para acompañar tu progreso. Gracias a sus materiales de larga duración y a los más altos estándares de calidad en su proceso de ensamble podrás disfrutar de tu motocarro por mucho tiempo.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 02.webp").default
                        }
                    ]
                },
                "Motocarro King Basico POSTERIOR": {
                    "Image": require("./../assets/panoramas/MTbasico_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -1.672",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico LAT DER"
                        },
                        {
                            "Position":"-2.479 0 1.713",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Basico LAT IZQ"
                        }
                    ]
                },

                "Motocarro King Carpa Especial": {
                    "Image": require("./../assets/panoramas/MTcarpaEspecial_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"12.405 0 -7.097",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"-1.536 0 7.389",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.948 0 -4.576",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTO MES"
                        },
                        {
                            "Position":"0.206 0 1.890",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"7.250 0 -6.358",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"2.244 0 12.259",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-4.650 0 10.932",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -2.025",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 2.043",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial LAT DER"
                        },
                        {
                            "Position":"-3.424 0 3.194",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full"
                        },
                        {
                            "Position":"2.215 0 -3.551",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Basico"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.708 -0.046",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su versatilidad y adaptabilidad a diversos terrenos, el TVS King está listo para acompañarte en tus jornadas de trabajo sin importar a donde vayas. Con este motocarro no te quedarás atrás.",
                            "Image": require("./../assets/bullets/MotocarroGSEspecial/Bullet 03.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-18.859 4.803 11.316",
                            "Rotation":"0 157.881 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Carpa Full",
                            "Image": require('./../UI/labels/king-full.png').default
                        },
                        {
                            "Position":"-3.215 5.059 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Basico",
                            "Image": require('./../UI/labels/king.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-15.192 -0.119 7.968",
                            "Rotation":"0 -5.979 0",
                            "Scale":"8.907 6.344",
                            "goTo":"Motocarro King Carpa Full",
                        },
                        {
                            "Position":"-2.580 -0.011 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Motocarro King Basico",
                        }
                    ]
                },
                "Motocarro King Carpa Especial LAT IZQ": {
                    "Image": require("./../assets/panoramas/MTcarpaEspecial_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"0.059 0 14.646",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-3.220 0 5.444",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"-9.920 0 11.396",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"2.064 0 15.706",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.972 0 -3.098",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial POSTERIOR"
                        },
                        {
                            "Position":"-1.163 0 1.890",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.585 -1.595",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Duralife patentada por TVS podrás disfrutar de muchas horas de manejo con un gasto mínimo de combustible. ¡Este motocarro es el aliado perfecto a la hora de ahorrar!",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 01.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Especial LAT DER": {
                    "Image": require("./../assets/panoramas/MTcarpaEspecial_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-6.036 0 -14.105",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"START"
                        },
                        {
                            "Position":"6.160 0 -1.424",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"-1.854 0 -12.293",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"MOTO MES"
                        },
                        {
                            "Position":"-2.094 0 -12.522",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NTORQ"
                        },
                        {
                            "Position":"12.312 0 1.685",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"12.312 0 -11.940",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"5.714 0 6.252",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"-1.114 0 -5.409",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-1.449 0 -2.636",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial"
                        },
                        {
                            "Position":"-3.636 0 2.922",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.455 1.388",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con el motocarro TVS King tendrás a tu alcance un vehículo práctico, versátil y muy duradero para acompañar tu progreso. Gracias a sus materiales de larga duración y a los más altos estándares de calidad en su proceso de ensamble podrás disfrutar de tu motocarro por mucho tiempo.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 02.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Especial POSTERIOR": {
                    "Image": require("./../assets/panoramas/MTcarpaEspecial_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -2.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial LAT DER"
                        },
                        {
                            "Position":"-2.479 0 2.344",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Especial LAT IZQ"
                        }
                    ]
                },

                "Motocarro King Carpa Full": {
                    "Image": require("./../assets/panoramas/MTcarpaFull_Frente.webp"),
                    "Rotation":"0 90 0",
                    "Bullets":[
                        {
                            "Position":"0.626 0 4.575",
                            "Rotation":"-90 154.649 -90.000",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"4.087 0 -1.325",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"4.220 0 9.678",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-1.813 0 7.620",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA NEO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.424 0 -2.025",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full LAT IZQ"
                        },
                        {
                            "Position":"-3.424 0 2.043",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Full LAT DER"
                        },
                        {
                            "Position":"4.642 0 -6.810",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"MMotocarro King Basico"
                        },
                        {
                            "Position":"2.177 0 -3.716",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"Motocarro King Carpa Especial"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.708 -0.046",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con su versatilidad y adaptabilidad a diversos terrenos, el TVS King está listo para acompañarte en tus jornadas de trabajo sin importar a donde vayas. Con este motocarro no te quedarás atrás.",
                            "Image": require("./../assets/bullets/MotocarroGSFull/Bullet 03.webp").default
                        }
                    ],
                    "Labels":[
                        {
                            "Position":"-3.215 5.059 -12.781",
                            "Rotation":"0.000 0 0",
                            "Scale":"7.235 1.024",
                            "goTo":"Motocarro King Especial",
                            "Image": require('./../UI/labels/king-especial.png').default
                        }
                    ],
                    "LabelsPlane":[
                        {
                            "Position":"-2.580 -0.011 -8.923",
                            "Rotation":"0 0 0",
                            "Scale":"7.075 6.344",
                            "goTo":"Motocarro King Especial",
                        }
                    ]
                },
                "Motocarro King Carpa Full LAT IZQ": {
                    "Image": require("./../assets/panoramas/MTcarpaFull_LateralIzq.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-5.790 0 6.787",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"5.330 0 16.196",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.8 0.8",
                            "goTo":"FAMILIA APACHE"
                        },
                        {
                            "Position":"0.910 0 5.444",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-3.856 0 -3.098",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full POSTERIOR"
                        },
                        {
                            "Position":"-2.026 0 1.901",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full"
                        },
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.585 -1.595",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Gracias a la tecnología Duralife patentada por TVS podrás disfrutar de muchas horas de manejo con un gasto mínimo de combustible. ¡Este motocarro es el aliado perfecto a la hora de ahorrar!",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 01.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Full LAT DER": {
                    "Image": require("./../assets/panoramas/MTcarpaFull_LateralDer.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"5.400 0 -2.229",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.5 0.5",
                            "goTo":"GENERAL1"
                        }
                    ],
                    "BulletsFamilia":[
                        {
                            "Position":"10.602 0 -0.224",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA SPORT"
                        },
                        {
                            "Position":"-0.599 0 -6.511",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.4 0.4",
                            "goTo":"FAMILIA MOTOCARRO"
                        },
                        {
                            "Position":"3.816 0 2.955",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.6 0.6",
                            "goTo":"FAMILIA NEO"
                        },
                        {
                            "Position":"9.978 0 -14.132",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"1 1",
                            "goTo":"FAMILIA APACHE"
                        }
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.273 0 -2.910",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full"
                        },
                        {
                            "Position":"-1.914 0 2.518",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full POSTERIOR"
                        }
                    ],
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.455 1.388",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":"Con el motocarro TVS King tendrás a tu alcance un vehículo práctico, versátil y muy duradero para acompañar tu progreso. Gracias a sus materiales de larga duración y a los más altos estándares de calidad en su proceso de ensamble podrás disfrutar de tu motocarro por mucho tiempo.",
                            "Image": require("./../assets/bullets/MotocarroGSBasico/Bullet 02.webp").default
                        }
                    ]
                },
                "Motocarro King Carpa Full POSTERIOR": {
                    "Image": require("./../assets/panoramas/MTcarpaFull_Posterior.webp"),
                    "Rotation":"0 180 0",
                    "Bullets":[
                        {
                            "Position":"-17.521 0 6.492",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0 0",
                            "goTo":"START"
                        }
                    ],
                    "BulletsFamilia":[
                    ],
                    "BulletsIndividuales":[
                        {
                            "Position":"-2.187 0 -2.143",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full LAT DER"
                        },
                        {
                            "Position":"-2.479 0 2.344",
                            "Rotation":"-90.000 90.000 0",
                            "Scale":"0.3 0.3",
                            "goTo":"Motocarro King Carpa Full LAT IZQ"
                        }
                    ]
                }
            }
        ] 
    }
}